import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import React from 'react'
import { NavLink } from 'react-router-dom'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

import styles from './SettingsController.module.sass'

const SettingsController = () => {
	const { i18n } = useGlobal()
	return (
		<VStack className={styles['header-options']}>
			<NavLink
				to='/settings/coordinator-allocation-rules'
				className={styles['settings-entry']}
				activeClassName={styles['--is-selected']}
			>
				<Icon
					name='coordinator-allocation'
					width='16px'
					height='16px'
				/>
				<h5
					className={styles['title']}
				>{i18n`Coordinator allocation rules`}</h5>
				<Icon name='chevron' width='16px' height='16px' />
			</NavLink>
		</VStack>
	)
}

export default SettingsController
